export const objectives = [
    {
       'id': 1,
       'type': 'SELL',
       'checked': false

    },
    {
       'id': 2,
       'type': 'RENT',
       'checked': false

    },
    {
       'id': 3,
       'type': 'GIVE',
       'checked': true
    },
];
